import type { Eigendom } from '@fleet/shared';
import { EIGENDOM_LABEL } from '@fleet/shared';

/**
 * The ownership forms as dropdown options, in the order `EIGENDOM_LABEL` declares
 * them.
 *
 * **Apart from `EigendomBevestiging.tsx`**: an array export next to a component
 * breaks fast refresh — the array is rebuilt on every module evaluation, so Vite
 * cannot swap the component in place. See `react-refresh/only-export-components` in
 * `eslint.config.js`.
 */
export const EIGENDOM_OPTIES = (Object.keys(EIGENDOM_LABEL) as Eigendom[]).map((value) => ({
  value,
  label: EIGENDOM_LABEL[value],
}));
